document.documentElement.classList.remove('no-js');

const qs = (selector, context = document) => context.querySelector(selector);
const qsa = (selector, context = document) => [...context.querySelectorAll(selector)];

function setCartCount(count) {
  qsa('[data-cart-count]').forEach((node) => {
    node.textContent = count;
    node.hidden = count < 1;
  });
}

function toast(message, error = false) {
  const node = qs('[data-cart-toast]');
  if (!node) return;
  node.textContent = message;
  node.hidden = false;
  node.classList.toggle('is-error', error);
  window.clearTimeout(window.anToastTimer);
  window.anToastTimer = window.setTimeout(() => { node.hidden = true; }, 2600);
}

async function refreshCartCount() {
  const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
  if (!response.ok) return;
  const cart = await response.json();
  setCartCount(cart.item_count);
}

document.addEventListener('click', (event) => {
  const menuButton = event.target.closest('[data-menu-toggle]');
  if (menuButton) {
    const menu = qs('[data-mobile-menu]');
    const open = menu.classList.toggle('is-open');
    menuButton.setAttribute('aria-expanded', String(open));
  }

  if (event.target.closest('[data-facets-open]')) {
    qs('[data-facets]')?.classList.add('is-open');
    qs('[data-facets-overlay]')?.classList.add('is-open');
    document.body.classList.add('facets-open');
  }
  if (event.target.closest('[data-facets-close]') || event.target.matches('[data-facets-overlay]')) {
    qs('[data-facets]')?.classList.remove('is-open');
    qs('[data-facets-overlay]')?.classList.remove('is-open');
    document.body.classList.remove('facets-open');
  }
});

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-sort-by]')) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    window.location.assign(url.toString());
  }
  if (event.target.matches('[data-filter-checkbox]')) {
    window.location.assign(event.target.checked ? event.target.dataset.addUrl : event.target.dataset.removeUrl);
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add]');
  if (!form) return;
  event.preventDefault();
  const button = qs('button[type="submit"]', form);
  const original = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding…';
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
    });
    if (!response.ok) throw new Error((await response.json()).description || 'Could not add item');
    await refreshCartCount();
    toast('Added to cart');
  } catch (error) {
    toast(error.message || 'Could not add item', true);
  } finally {
    button.disabled = false;
    button.textContent = original;
  }
});
